import { MerchantWorkScheduleCommand } from "@/models/club";
import clubRequest from "../axios";

const getWorkingHours = async () =>
  (await clubRequest.merchantWorkScheduleList()).data;

const updateWorkingHours = async (data: MerchantWorkScheduleCommand) =>
  (await clubRequest.merchantWorkScheduleCreate(data)).data;

export { getWorkingHours, updateWorkingHours };
